import { Pipe, PipeTransform } from '@angular/core';

import { ProductCategory } from '@iss/wo-common/trade-off';

type OrderLineData = Readonly<{
  productData: Readonly<{
    productCategory: ProductCategory;
  }>
}>;
type OrderLine<T extends OrderLineData> = T;
type OrderLinePipeInput<T extends OrderLineData> = readonly OrderLine<T>[];

export const isDisposalOrderLine = (input: OrderLineData) => input.productData.productCategory === 'DISPOSAL';

@Pipe({
  name: 'disposalOrderLine',
  standalone: true,
})
export class DisposalOrderLinePipe implements PipeTransform {
  public transform<T extends OrderLineData>(input: OrderLinePipeInput<T>): OrderLine<T> | undefined {
    return input.find(isDisposalOrderLine);
  }
}
